import { apiClient, unwrapApiResult } from '@/lib/openapi-client';
import type {
  ConfirmForgotPasswordRequest,
  CurrentUserResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  InvitationPrefillResponse,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  RefreshResponse,
  ResendVerificationRequest,
  SignupKindsResponse,
  SignupRequest,
  SignupResponse,
  SocialProvidersResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
} from '@/types/generated';

export const authApi = {
  me: (): Promise<CurrentUserResponse> =>
    unwrapApiResult(apiClient.GET('/api/v1/auth/me')),

  login: (data: LoginRequest): Promise<LoginResponse> =>
    unwrapApiResult(apiClient.POST('/api/v1/auth/login', { body: data })),

  logout: (): Promise<LogoutResponse> =>
    unwrapApiResult(apiClient.POST('/api/v1/auth/logout')),

  refresh: (): Promise<RefreshResponse> =>
    unwrapApiResult(apiClient.POST('/api/v1/auth/refresh')),

  signup: (data: SignupRequest): Promise<SignupResponse> =>
    unwrapApiResult(apiClient.POST('/api/v1/auth/signup', { body: data })),

  socialProviders: (): Promise<SocialProvidersResponse> =>
    unwrapApiResult(apiClient.GET('/api/v1/auth/oauth/providers')),

  signupKinds: (): Promise<SignupKindsResponse> =>
    unwrapApiResult(apiClient.GET('/api/v1/auth/signup/kinds')),

  verifyEmail: (data: VerifyEmailRequest): Promise<VerifyEmailResponse> =>
    unwrapApiResult(
      apiClient.POST('/api/v1/auth/verify-email', { body: data }),
    ),

  resendVerification: (
    data: ResendVerificationRequest,
  ): Promise<{ message: string }> =>
    unwrapApiResult(
      apiClient.POST('/api/v1/auth/verify-email/resend', { body: data }),
    ),

  forgotPassword: (
    data: ForgotPasswordRequest,
  ): Promise<ForgotPasswordResponse> =>
    unwrapApiResult(
      apiClient.POST('/api/v1/auth/forgot-password', { body: data }),
    ),

  confirmForgotPassword: (data: ConfirmForgotPasswordRequest): Promise<void> =>
    unwrapApiResult(
      apiClient.POST('/api/v1/auth/forgot-password/confirm', { body: data }),
    ),

  resolveInvitation: (token: string): Promise<InvitationPrefillResponse> =>
    unwrapApiResult(
      apiClient.POST('/api/v1/auth/resolve-invitation', { body: { token } }),
    ),
} as const;
